import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Categorys.css";
import cImg1 from '../../images/category/entretenimiento.jpg'
import cImg2 from '../../images/category/experiencias.jpg'
import cImg3 from '../../images/category/hogar.jpg'
import cImg4 from '../../images/category/luna-de-miel.jpg'
import cImg5 from '../../images/category/mascotas.jpg'
import cImg6 from '../../images/category/vida-cotidiana.jpg'

const Categorys = ({ selectedCategory, onCategorySelect }) => {
    const categories = [
        {
            id: 1,
            image: cImg1,
            title: "Entretenimiento",
            slug: "entretenimiento"
        },
        {
            id: 2,
            image: cImg2,
            title: "Experiencias",
            slug: "experiencias"
        },
        {
            id: 3,
            image: cImg3,
            title: "Hogar",
            slug: "hogar"
        },
        {
            id: 4,
            image: cImg4,
            title: "Luna de miel",
            slug: "luna-de-miel"
        },
        {
            id: 5,
            image: cImg5,
            title: "Mascotas",
            slug: "mascotas"
        },
        {
            id: 6,
            image: cImg6,
            title: "Vida cotidiana",
            slug: "vida-cotidiana"
        }
    ];

    // Slider settings
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const handleCategoryClick = (category) => {
        if (onCategorySelect) {
            onCategorySelect(category);
        }
    };

    const isCategorySelected = (category) => {
        return selectedCategory && selectedCategory.id === category.id;
    };

    return (
        <section className="wpo-category-section" style={{ marginTop: '4rem', marginBottom: '4rem' }}>
            <h2 className="hidden">Category</h2>
            <div className="container">
                <div className="wpo-category-wrap">
                    <Slider {...sliderSettings}>
                        {categories.map((category) => (
                            <div key={category.id} className="category-slide">
                                <div 
                                    className={`wpo-category-item ${isCategorySelected(category) ? 'category-selected' : ''}`}
                                    onClick={() => handleCategoryClick(category)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="category-image-container">
                                        <img
                                            src={category.image}
                                            alt={category.title}
                                            className="category-image"
                                        />
                                    </div>
                                    <div className={`wpo-category-text ${isCategorySelected(category) ? 'category-text-selected' : ''}`}>
                                        {category.title}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default Categorys;